import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { LoaderService } from '../../../services/loader.service';

import { KostenService } from '../../../services/facetten/instance/kosten.service';

import { map } from 'rxjs/operators';
import { CheckboxFacetteComponent } from '../../checkbox-facette/checkbox-facette.component';
import { FilterSelectItem } from '../../checkbox-facette/checkbox-liste/filterSelectItem';
import { BasisFacetteComponent } from '../basis-facette/basis-facette.component';

@Component({
  selector: 'now-wbsuche-lib-kosten-facette',
  templateUrl: './kosten-facette.component.html',
  imports: [BasisFacetteComponent, CommonModule, CheckboxFacetteComponent],
  styleUrls: ['kosten-facette.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class KostenFacetteComponent {
  facettenService = inject(KostenService);
  loaderService = inject(LoaderService);

  public expanded$ = this.facettenService.expanded$;
  public items$ = this.facettenService.getSelectItems$().pipe(
    //"PREISVERHANDELTE_MASSNAHME" soll nicht als Filter angezeigt werden. => ID '-1'
    map((items) => items.filter((item) => item.key !== '-1'))
  );

  public updateSelectedIds(selectedItems: FilterSelectItem[]): void {
    const selectedIds = selectedItems.map((item) => item.key);
    this.facettenService.updateSelectedIds(selectedIds);
  }
}
